// Uploads an image directly from the browser to ImgBB (free image host) and
// returns a public URL. Used so a Hostinger static export (no backend) can
// still include a clickable photo link in email/WhatsApp enquiries.
const ALLOWED_TYPES = ["image/jpeg", "image/png", "image/webp", "image/gif"];
const MAX_SIZE = 32 * 1024 * 1024; // ImgBB free-tier limit

export function isImageFile(file) {
  return !!file && ALLOWED_TYPES.includes(file.type);
}

export async function uploadToImgBB(file) {
  const key = process.env.REACT_APP_IMGBB_API_KEY;
  if (!key) throw new Error("Image hosting is not configured.");
  if (!isImageFile(file)) throw new Error("Only JPEG, PNG, WEBP or GIF images can be auto-linked.");
  if (file.size > MAX_SIZE) throw new Error("Image must be 32 MB or smaller.");

  const form = new FormData();
  form.append("image", file, file.name);

  const res = await fetch(`https://api.imgbb.com/1/upload?key=${encodeURIComponent(key)}`, {
    method: "POST",
    body: form,
  });
  const payload = await res.json().catch(() => null);
  if (!res.ok || !payload?.success) {
    throw new Error(payload?.error?.message || "Photo upload failed.");
  }
  return payload.data.url;
}
